
import React from 'react';
import { Card } from '@/components/ui/card';

const EventsLoadingSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {[1, 2, 3].map((i) => (
        <Card key={i} className="h-64 animate-pulse bg-gray-100"></Card>
      ))}
    </div>
  );
};

export default EventsLoadingSkeleton;
